import { BrowserRouter, Routes, Route } from "react-router-dom";
import NavBar from "./components/NavBar";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Appointment from "./pages/Appointment";
import Room from "./pages/Room";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton"; // Keep for quick customer chatting
import About from "./pages/About";
import Schedule from "./pages/Schedule";

function App() {
  return (
    <div className="min-h-screen bg-white selection:bg-green-200">
      <BrowserRouter>
        {/* Navigation Header Bar */}
        <NavBar />
        
        {/* Application Page Routing System */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/appointment" element={<Appointment />} />
          <Route path="/room" element={<Room />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
        </Routes>
        
        {/* FLOATING ACTION: Keep only WhatsApp floating for high conversion */}
        <WhatsAppButton />
        
        {/* Persistent Base Footer */}
        <Footer />
      </BrowserRouter>   
    </div>
  );
}

export default App;